import { Phone, Mail, Clock, MapPin, Zap, Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Logo";
import { CONTACT, INSTAGRAM_URL, NAV_LINKS } from "@/lib/site";
import { scrollToSection } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-[#1e293b] bg-[#0F172A] pt-20">
      <div className="mx-auto w-full max-w-7xl px-5 lg:px-8">
        <div className="grid gap-12 pb-16 lg:grid-cols-[1.2fr_1fr_1fr]">
          <div>
            <LogoMark size={44} />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-300">
              Réparation, rachat et reconditionné d'appareils à {CONTACT.city} (74800).
              Repair. Renew. Repeat.
            </p>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#38BDF8]">Navigation</p>
            <div className="mt-4 grid gap-2.5">
              {NAV_LINKS.map((l) => (
                <button
                  key={l.href}
                  data-testid={`footer-link-${l.href.slice(1)}`}
                  onClick={() => scrollToSection(l.href)}
                  className="w-fit text-sm font-semibold text-slate-300 transition-colors duration-200 hover:text-[#38BDF8]"
                >
                  {l.label}
                </button>
              ))}
              <button
                data-testid="footer-link-devis"
                onClick={() => scrollToSection("#devis")}
                className="w-fit text-sm font-semibold text-slate-300 transition-colors duration-200 hover:text-[#38BDF8]"
              >
                Demande de devis
              </button>
            </div>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#38BDF8]">Contact</p>
            <div className="mt-4 grid gap-3.5 text-sm">
              <a href={CONTACT.phoneHref} className="flex items-center gap-3 font-semibold text-[#f1f5f9] transition-colors hover:text-[#38BDF8]">
                <Phone size={15} className="text-[#38BDF8]" /> {CONTACT.phoneDisplay}
              </a>
              <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 font-semibold text-[#f1f5f9] transition-colors hover:text-[#38BDF8]">
                <Mail size={15} className="text-[#38BDF8]" /> {CONTACT.email}
              </a>
              <p className="flex items-center gap-3 text-slate-300">
                <MapPin size={15} className="text-[#38BDF8]" /> {CONTACT.address}
              </p>
              <p className="flex items-center gap-3 text-slate-300">
                <Clock size={15} className="text-[#38BDF8]" /> {CONTACT.hours}
              </p>
              <a
                data-testid="footer-instagram-link"
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 w-fit font-semibold text-[#f1f5f9] transition-colors duration-200 hover:text-[#38BDF8]"
              >
                <span className="flex h-7 w-7 items-center justify-center rounded-lg border border-[#38BDF8]/30 bg-[#38BDF8]/10 text-[#38BDF8]">
                  <Instagram size={15} />
                </span>
                @maxrevix sur Instagram
              </a>
            </div>
          </div>
        </div>

        <div className="select-none border-t border-white/10 pt-8" aria-hidden="true">
          <p className="text-center font-display text-[18vw] font-black uppercase leading-[0.8] tracking-tight text-white/[0.045] lg:text-[11rem]">
            MAXREVIX
          </p>
        </div>

        <div className="flex flex-col items-center justify-between gap-3 border-t border-white/10 py-7 text-[11px] text-slate-400 sm:flex-row">
          <p>© {new Date().getFullYear()} MAXREVIX — Tous droits réservés.</p>
          <p className="flex items-center gap-2">
            <Zap size={11} className="text-[#38BDF8]" />
            <Link data-testid="footer-mentions-link" to="/mentions-legales" className="transition-colors duration-200 hover:text-[#38BDF8]">Mentions légales</Link>
            <span className="text-slate-600">·</span>
            <Link data-testid="footer-cgv-link" to="/cgv" className="transition-colors duration-200 hover:text-[#38BDF8]">CGV</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
